<template>
    <div class="func-search-form">
        <div class="func-search-form__nav">
            <div
            v-if="showTab('E-wizyta')"
            class="nav-item"
            :class="{'nav-item--active': visitType === 'evisit'}"
            @click="visitType = 'evisit'">
                <p>umów<br><b>e-wizytę</b></p>
            </div>
            <div
            v-if="showTab('Stacjonarnie')"
            class="nav-item"
            :class="{'nav-item--active': visitType === 'stationary'}"
            @click="visitType = 'stationary'">
                <p>umów<br><b>wizytę stacjonarną</b></p>
            </div>
        </div>
        <div class="func-search-form__content">
            <div v-if="$v.$error" class="form-error">
                proszę uzupełnić dane
            </div>
            <div class="search-row">
                <div class="search-row__icon">
                    <img src="~@/assets/icons/doctor-ico-white.svg" />
                </div>
                <div class="search-row__content" :class="{'search-row__content--error': $v.selectedDoctor.$error}">
                    <vselect
                    placeholder="Wybierz specjalizację / lekarza"
                    :promotedItems="specialitiesComp"
                    :items="doctorsComp"
                    :value="getDoctorSelectValue"
                    :searchable="true"
                    @live="search.doctors = $event; search.specialities = $event;"
                    @input="selectDoctor($event)">

                        <template #display="{item}">
                            <span v-if="item.specialties">{{item.first_name}} {{item.last_name}}</span>
                            <span v-else>{{item.name}}</span>
                        </template>

                        <template #promotedTitle>Specjalizacja</template>

                        <template #promotedItem="{item}">
                            {{ item.name }}
                        </template>

                        <template #itemsTitle>Lekarz</template>

                        <template #item="{item}">
                            {{ item.first_name }} {{ item.last_name }}<br> <span>{{
                                item.specialties && item.specialties.length ?
                                    `(${item.specialties.join(', ')})` : `(${item.prof_code})`
                            }}</span>
                      </template>

                        <template #noItems>
                            Brak specjalizacji / lekarzy do wyboru
                        </template>

                    </vselect>
                    <small v-if="!$v.selectedDoctor.isValid">To pole jest wymagane.</small>
                </div>
            </div>
            <div class="search-row" :class="{'search-row--disabled': visitType !== 'stationary'}">
                <div class="search-row__icon">
                    <img src="~@/assets/icons/city-ico-white.svg" />
                </div>
                <div class="search-row__content" :class="{'search-row__content--error': $v.selectedCity.$error}">
                    <vselect
                    :promotedItems="cities.length > 1 ? [{ name: 'Dowolne' }] : []"
                    :items="citiesComp"
                    placeholder="Wybierz miasto"
                    label="name"
                    :searchable="true"
                    @live="search.cities = $event;"
                    v-model="selectedCity">
                        <template #noItems>
                            Brak miast do wyboru
                        </template>
                    </vselect>
                    <small v-if="!$v.selectedCity.isValid">To pole jest wymagane.</small>
                </div>
            </div>
            <div class="search-row">
                <div class="search-row__icon">
                    <img src="~@/assets/icons/calendar-ico-white.svg" />
                </div>
                <div class="search-row__content--splited">
                    <div class="search-row__content" :class="{'search-row__content--error': $v.visitDate.$error}">
                        <datepicker
                        placeholder="Wybierz datę"
                        :clearable="false"
                        :days="$config.FORMATS.DAY_NAMES"
                        :months="$config.FORMATS.MONTH_NAMES"
                        :disableBefore="`${new Date()}`"
                        displayFormat="dd.mm.yyyy"
                        outputFormat="yyyy-mm-dd"
                        v-model="visitDate"/>
                        <small v-if="!$v.visitDate.required">To pole jest wymagane.</small>
                    </div>
                    <switcher
                    v-if="facility.patient_visit_kinds_options.length > 1 && !this.app__isMobile()"
                    v-model="visitKind"
                    offLabel="Prywatna"
                    onLabel="NFZ"/>
                </div>
            </div>
            <div class="content-footer">
                <switcher
                v-if="facility.patient_visit_kinds_options.length > 1 && this.app__isMobile()"
                v-model="visitKind"
                offLabel="Prywatna"
                onLabel="NFZ"/>
                <btn type="search" :defaultIcon="true" @click="emitData()">sprawdź terminy</btn>
            </div>
        </div>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import dateFormat from 'dateformat';
import vselect from '@/components/ui/vselect/vselect.vue';
import datepicker from '@/components/ui/datepicker/datepicker.vue';
import switcher from '@/components/ui/switcher/switcher.vue';
import debounce from 'lodash.debounce';

export default {

    name: 'searchForm',
    mixins: [validationMixin],
    components: {

        vselect,
        datepicker,
        switcher,

    },
    props: {

        data: {
            type: Object,
            default: () => {},
            required: true,
        },

        facility: {
            type: Object,
            default: () => {},
            required: true,
        },

        type: {
            type: String,
            default: 'evisit',
        },

        kind: {
            type: String,
            default: 'Prywatna',
        },

    },
    data(){
        return {

            cities: [],
            doctors: [],
            specialities: [],

            visitType: 'evisit',
            selectedDoctor: null,
            selectedSpeciality: null,
            selectedCity: null,
            visitDate: null,
            visitKind: false,

            search: {
                cities: '',
                doctors: '',
                specialities: '',
            },

        };
    },
    validations: {
        visitDate: { required },
        selectedDoctor: {
            isValid() {
                if (this.selectedDoctor || this.selectedSpeciality) return true;
                return false;
            },
        },
        selectedCity: {
            isValid() {

                if (this.visitType !== 'evisit'){
                    if (this.selectedCity) return true;
                    return false;
                }

                return true;
            },
        },
    },
    watch: {

        data: {
            handler: function(val, oldVal) { // eslint-disable-line
                this.setData();
            },
            deep: true,
        },

        type(){
            this.visitType = this.type;
        },

        kind(){
            this.setKind();
        },

    },
    methods: {

        init(){

            const loader = this.app__setLoader();
            this.setData();
            this.app__loaderDequeue(loader);

        },

        setData(){

            if (this.type) this.visitType = this.type;
            if (this.kind) this.setKind();

            if (!Object.keys(this.data).length) return;

            this.cities = this.data.cities || [];
            this.doctors = this.data.doctors || [];
            this.specialities = this.data.specialities || [];

            this.selectedDoctor = this.data.selectedDoctor || null;
            this.selectedCity = this.data.selectedCity || null;
            this.selectedSpeciality = this.data.selectedSpeciality || null;
            this.visitDate = this.data.visitDate || dateFormat(new Date(), 'yyyy-mm-dd');

        },

        setKind(){
            this.visitKind = this.kind === 'NFZ';
        },

        searching: debounce(function(type, query) { // eslint-disable-line
            if (['person', 'specialty'].includes(type)) {
                const promises = [this.getSugestions('person', query), this.getSugestions('specialty', query)];

                Promise.all(promises).then(data => {
                    this.doctors = [...data[0]];
                    this.specialities = [...data[1]];
                });
                return;
            }

            if (['city'].includes(type)) {
                const promises = [this.getSugestions('city', query)];

                Promise.all(promises).then(data => {
                    this.cities = [...data[0]];
                });
                return;
            }

            this.getSugestions(type, query).then(data => { this[type] = data; });
        }, 500),

        getSugestions(type, query){

            return new Promise((resolve, reject) => {

                this.app__getToken().then(token => {

                    this.$http.get('visits/search_autosuggest/', {
                        headers: {
                            'Content-Type': 'Application/json',
                        },
                        params: {
                            selected_facility_token: token.accessToken,
                            remote_app: token.remoteApp,
                            search_type: type,
                            q: query,
                        },
                    }).then(response => {

                        resolve(response.data);

                    }).catch(error => {
                        this.app__handleHttpFailureResponse(error);
                        reject(new Error(error));
                    });

                });

            });

        },

        selectDoctor(data){

            this.selectedDoctor = null;
            this.selectedSpeciality = null;

            if (data.specialties) this.selectedDoctor = data;
            if (data.name) this.selectedSpeciality = data;

        },

        showTab(tab){
            const types = this.facility.patient_visit_performances_options;
            return types.find(ob => ob.label === tab);
        },

        emitData(){

            this.$v.$touch();
            if (this.$v.$invalid) return;

            const data = {
                visitType: this.visitType,
                doctor: this.selectedDoctor,
                speciality: this.selectedSpeciality,
                city: this.selectedCity,
                visitDate: this.visitDate,
                visitKind: this.visitKind ? 'NFZ' : 'Prywatna',
            };

            this.$emit('search', data);

        },

    },
    computed: {

        getDoctorSelectValue(){
            if (this.selectedDoctor) return this.selectedDoctor;
            if (this.selectedSpeciality) return this.selectedSpeciality;
            return '';
        },

        doctorsComp(){

            if (!this.search.doctors) return this.doctors;

            const results = this.doctors.filter(item => {

                const doctor = `${item.first_name} ${item.last_name}`.toLowerCase();
                return doctor.includes(this.search.doctors.toLowerCase());

            });

            return results;

        },

        specialitiesComp(){

            if (!this.search.specialities) return this.specialities;

            const results = this.specialities.filter(item => {

                return item?.name.toLowerCase().includes(this.search.specialities.toLowerCase());

            });

            return results;

        },

        citiesComp(){

            if (!this.search.cities) return this.cities;

            const results = this.cities.filter(item => {

                return item?.name.toLowerCase().includes(this.search.cities.toLowerCase());

            });

            return results;

        },

    },
    created(){
        this.init();
    },

};

</script>

<style lang="scss" src="./searchForm.scss" />
